import { Fragment } from "react";
import { useMediaQuery } from "@mui/material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { formatItem } from "@framework/exchange";
import { ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { ClaimStatus, ClaimType, IClaim } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { ClaimRedeemButton, VestingDeployButton } from "../../../../../components/buttons";
import { ClaimSearchForm } from "./search";

const initialSearchValues = {
  claimStatus: [ClaimStatus.NEW],
  claimType: [ClaimType.VESTING, ClaimType.TOKEN, ClaimType.TEMPLATE],
};

export const Claim = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IClaim>
  >("/claim", { enableInfiniteScroll: isMd }, void 0, initialSearchValues);

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "claim"]} />

      <PageHeader message="pages.claim.title" />

      <ClaimSearchForm initialValues={initialSearchValues} />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(claim => (
            <StyledListItem key={claim.id}>
              <List.ItemText sx={{ width: { xs: 0.6, md: 0.2 } }}>{claim.claimType}</List.ItemText>
              <List.ItemText sx={{ width: { xs: 0.6, md: 0.2 } }}>{formatItem(claim.item)}</List.ItemText>
              <ListActions>
                {claim.claimType === ClaimType.TOKEN || claim.claimType === ClaimType.TEMPLATE ? (
                  <ClaimRedeemButton claim={claim} />
                ) : (
                  <VestingDeployButton claim={claim} />
                )}
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
